const ChannelLevel = Object.freeze({
  NONE: 'NONE',
  INSTAGRAM_INCIDENTAL_MATCH: 'INSTAGRAM_INCIDENTAL_MATCH',
  INSTAGRAM_BUSINESS: 'INSTAGRAM_BUSINESS',
  INSTAGRAM_OWN: 'INSTAGRAM_OWN',
  INSTAGRAM_MODERATE: 'INSTAGRAM_MODERATE',
  FACEBOOK_ADVERTISE: 'FACEBOOK_ADVERTISE',
  FACEBOOK_BASIC: 'FACEBOOK_BASIC'
} as const)
export default ChannelLevel
export type ChannelLevelStrings = typeof ChannelLevel[keyof typeof ChannelLevel]
// RESERVE BELOW
